import Link from 'next/link';
import H5 from '../../headings/H5';
import Iconify from '../../Iconify';

const BgLinkButton = ({
  children,
  className,
  icon,
  iconClassName,
  link,
  onClick = () => { },
  setHover,
  isHidden,
}) => {

  return (
    <>
      {link ? (
        <Link href={link}>
          <div
            className={`group ${isHidden ? "hidden" : "flex"} flex justify-between items-center dark:hover:bg-brown hover:bg-light_bg_grey h-10 px-3 cursor-pointer rounded-lg ${className}`}
          >
            <H5
              className={
                '!text-nowrap !font-normal group-hover:!text-light_primary_label group-hover:dark:!text-dark_primary_label dark:!text-dark_secondary_label !text-light_secondary_label'
              }
            >
              {children}
            </H5>
            <Iconify
              icon={icon}
              className={`hidden group-hover:flex dark:!text-light_primary_label dark:!text-grey-500 !text-gray-400 !w-6 !h-6 -rotate-45 ${iconClassName}`}
            />
          </div>
        </Link>
      ) : (
        <div
          className={`group ${isHidden ? "hidden" : "flex"} justify-between items-center dark:hover:bg-brown hover:bg-light_bg_grey h-10 px-3 cursor-pointer rounded-lg ${className}`}
          onClick={() => {
            onClick();
            setHover(false);
          }}
        >
          <H5
            className={
              '!text-nowrap !font-normal group-hover:!text-light_primary_label group-hover:dark:!text-dark_primary_label dark:!text-dark_secondary_label !text-light_secondary_label'
            }
          >
            {children}
          </H5>
        </div>
      )}
    </>
  );
};

export default BgLinkButton;
